import { openSection } from 'assets/themes/campings/js/page/product/navigation'

export default (): void => {
  const linkEl = document.querySelector<HTMLElement>('.product-reviews-summary .ratings > a')

  if (!linkEl) {
    return
  }

  const target = linkEl.getAttribute('href')?.replace('#', '')

  if (!target) {
    return
  }

  openSection(target)
}
